<template>
    <rkm-layout-body title="Lista de serviço">
        <template v-slot:actions>
            <rkm-button
                @click="$router.push({ name: 'ambulatorio-servico-create' })"
                authorize="store-ambulatorio-servico"
                color="primary"
            >
                Cadastrar serviço
            </rkm-button>
        </template>

        <rkm-layout-content>
            <List />
        </rkm-layout-content>
    </rkm-layout-body>
</template>

<script>
// Components.
import List from '@/components/ambulatorio/servico/List'

export default {
    components: { List },
}
</script>